import dayjs from 'dayjs'
import { ss } from './constant'
// import { useSystemConfigStore } from '../stores/systemConfigStore'

export function encodePassword(pass: any, salt = ss) {
  const passStr = `password=${pass}&secret=${salt}`
  return `1aA${encodeURIComponent(btoa(encodeURIComponent(passStr)))}`
}
export function decodePassword(str: any){
  if(!str) return;
  const c =  decodeURIComponent(atob(decodeURIComponent(str.slice(3))))
   // @ts-ignore
  const res = c.match(/password=(\S*)&secret=/)[1];
  return res;
}

export function getRandom() {
  const randomStr = function (n: number) {
    const str = 'abcdefghijklmnopqrstuvwxyz9876543210'
    let tmp = ''
    let i = 0
    const l = str.length
    for (i = 0; i < n; i++) {
      // tmp += str.charAt(Math.floor(Math.random() * l));
      tmp += JSON.parse(JSON.stringify(Math.floor(Math.random() * l))[0])
    }
    return tmp
  }
  return (
    randomStr(8) +
    '-' +
    randomStr(4) +
    '-' +
    randomStr(4) +
    '-' +
    randomStr(4) +
    '-' +
    randomStr(12)
  )
}

export function getformatTime() {
  const day = dayjs()
  return day.format('YYYY/MM/DD HH:mm:ss')
}

export function formatTime(timestamp: any) {
  timestamp = Math.floor(timestamp)
  if (timestamp) {
    const day = timestamp.toString().length === 10 ? dayjs.unix(timestamp) : dayjs(timestamp)
    return day.format('YYYY/MM/DD HH:mm')
  }
  return '--'
}

export function formatTimeAll(timestamp: any) {
  timestamp = Math.floor(timestamp)
  if (timestamp) {
    const day = timestamp.toString().length === 10 ? dayjs.unix(timestamp) : dayjs(timestamp)
    return day.format('YYYY/MM/DD HH:mm:ss')
  }
  return '--'
}

export function prevPage(page: {
  offset: number
  limit: number
  currentPage: number
}) {
  page.offset -= page.limit
  page.currentPage -= 1
  return page
}

export function nextPage(page: {
  offset: any
  limit: any
  currentPage: number
}) {
  page.offset += page.limit
  page.currentPage += 1
  return page
}

export function jumpToPage(
  page: { offset: number; limit: number; currentPage: any },
  pageNo: number
) {
  page.offset = (pageNo - 1) * page.limit
  page.currentPage = pageNo
  return page
}

export function getTimeMinuteAndSecond(time: any) {
  if (time === 0 || time === '0') {
    return '0秒'
  }
  if (!time) {
    return '-'
  }
  const m = Math.floor(Number((time / 1000 / 60)))
  const s = ((time / 1000) % 60).toFixed(0)
  return (m ? m + '分' : '') + ' ' + (s ? s + '秒' : '')
}

export function formateTimeDay(timestamp: any) {
  timestamp = Math.floor(timestamp)
  if (timestamp) {
    let time = new Date(timestamp)
    if (timestamp.toString().length === 10) {
      time = new Date(timestamp * 1000)
    }
    const Y = time.getFullYear()
    const M =
      time.getMonth() + 1 < 10 ? `0${time.getMonth() + 1}` : time.getMonth() + 1
    const D = time.getDate() < 10 ? `0${time.getDate()}` : time.getDate()
    return `${Y}-${M}-${D}`
  }
  return '--'
}

export function formateNoTime(timestamp: any) {
  timestamp = Math.floor(timestamp)
  if (timestamp) {
    let time = new Date(timestamp)
    if (timestamp.toString().length === 10) {
      time = new Date(timestamp * 1000)
    }
    const Y = time.getFullYear()
    const M =
      time.getMonth() + 1 < 10 ? `0${time.getMonth() + 1}` : time.getMonth() + 1
    const D = time.getDate() < 10 ? `0${time.getDate()}` : time.getDate()
    return `${Y}-${M}-${D}`
  }
  return '--'
}

export function pre(query: { offset: number; limit: number; current: number }) {
  query.offset -= query.limit
  query.current -= 1
  return query
}
export function next(query: { offset: any; limit: any; current: number }) {
  query.offset += query.limit
  query.current += 1
  return query
}
export function jumpTo(
  num: number,
  query: { offset: number; limit: number; current: any }
) {
  query.offset = (num - 1) * query.limit
  query.current = num
  return query
}

export function formatFileSize(size: number) {
  const scale = 1024
  const digitList = ['KB', 'MB', 'GB', 'TB']
  let _integer = Number((size / scale).toFixed(2))
  let _digit = 0
  while (_integer > scale) {
    _integer = Number((_integer / scale).toFixed(2))
    _digit++
  }
  return `${_integer}${digitList[_digit]}`
}

export function IsPC() {
  const userAgentInfo = navigator.userAgent

  const Agents = [
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod',
  ]
  let flagPc = true

  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flagPc = false
      break
    }
  }
  return flagPc
}

// 字节转换，最高只到T
export function bytesTrans(size: number) {
  const byte = 1024
  const finalUnitObj = {
    value: 0,
    unit: '',
  }
  /* if (size < byte) {
    finalUnitObj.value = size
    finalUnitObj.unit = ' Byte'
  } else if ((size >= Math.pow(byte, 1)) && (size < Math.pow(byte, 2))) {
    finalUnitObj.value = (size / Math.pow(byte, 1).toFixed(2))
    finalUnitObj.unit = ' K'
  } else */
  if (size < Math.pow(byte, 3)) {
    // MB
    finalUnitObj.value = Number((size / Math.pow(byte, 2)).toFixed(2))
    finalUnitObj.unit = 'M'
  } else if (size >= Math.pow(byte, 3) && size < Math.pow(byte, 4)) {
    // GB
    finalUnitObj.value = Number((size / Math.pow(byte, 3)).toFixed(2))
    finalUnitObj.unit = 'G'
  } else {
    // TB
    finalUnitObj.value = Number((size / Math.pow(byte, 4)).toFixed(2))
    finalUnitObj.unit = 'T'
  }
  return finalUnitObj
}

/**
 * 解析作品类型字符串
 * @param {String} creativeType 作品类型名称
 * @returns
 */
export function getCreativeTypeText(creativeType: any) {
  switch (creativeType) {
    case 'animation':
      return 'H5'
    case 'article':
      return '图文'
    case 'topic':
      return '专题'
    case 'video':
      return '视频'
    case 'chart':
      return '图表'
    case 'template':
      return '模板'
    default:
      return '-'
  }
}

/**
 * 获取发布状态
 * @param {Int} status
 * @returns
 */
export function getPublishStatusText(status: any) {
  switch (status) {
    case 0:
      return '预览稿'
    case 1:
      return '已发布'
    case 3:
      return '待确认'
    case 4:
      return '未通过'
    case 5:
      return '待审核'
    default:
      return '-'
  }
}

/**
 * 获取第三方系统的入库状态
 * @param {String} status
 * @returns
 */
export function getForeignStatusText(status: string | number) {
  switch (status) {
    case 0:
    case '0':
      return '初稿'
    case 10:
    case '10':
      return '流转中'
    case 30:
    case '30':
      return '审核通过'
    case -1:
    case '-1':
      return '初稿(已驳回)'
    case 60:
    case '60':
      return '重新编辑'
    default:
      return '-'
  }
}

/**
 * 跳转到登录页面
 * @param {string?} redirect_url  登录后要跳转的url
 */
export function jumpToLogin(redirect_url?: string) {
  let newHref = '/rm/home/index?position=login_box&register=false'

  if (redirect_url) {
    newHref += '&redirect_url=' + encodeURIComponent(redirect_url)
  }

  window.location.href = newHref
}

/**
 * 对于没有域名的图片，主动增加域名头
 * @returns
 */
export const setUrlHost = (imgurl:string) => {
  if (!imgurl) {
    return ''
  }
  if (imgurl.indexOf('//') > -1) {
    return imgurl
  } else {
    return imgurl
  }
}

export const getHaidianApiBase = () => {
  switch (window.location.host) {
    case 'hd_test_front.mugeda.com':
      return '//hd_test_backend.mugeda.com'
    case 'rm.bjhdnet.com':
      return '//backend.bjhdnet.com'
    case 'rm.mugeda.com':
    case 'rongyi.xinhuaskl.com':
      return '//hd_backend.mugeda.com'
    default:
      return '//backend.bjhdnet.com'
  }
}

export const getFileSize = (fileByte:number) => {
  const fileSizeByte = fileByte;
  let fileSizeMsg = "";
  if(fileSizeByte < 1024){
      fileSizeMsg = fileSizeByte  + "B";
  }else if (fileSizeByte < 1048576) {
      fileSizeMsg = window.parseFloat(((fileSizeByte / 1024)).toFixed(2)) + "KB";
  }else if (fileSizeByte == 1048576) {
      fileSizeMsg = "1MB";
  }else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824){
      fileSizeMsg = window.parseFloat(((fileSizeByte / (1024 * 1024))).toFixed(2)) + "MB";
  }else if (fileSizeByte > 1048576 && fileSizeByte == 1073741824){
      fileSizeMsg = "1GB";
  }else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776){
      fileSizeMsg = window.parseFloat(((fileSizeByte / (1024 * 1024 * 1024))).toFixed(2)) + "GB";
  }else{
      fileSizeMsg = "文件超过1TB";
  }
  return fileSizeMsg;
}


export function downloadFile(url: string, fileName?: string) {
  const a = document.createElement('a')
  a.setAttribute('href', url)
  if (fileName) {
    a.setAttribute('download', fileName)
  }
  a.click()
}


/**
 * 自动补全域名
 *
 * @param path
 * @param defaultValue
 * @returns
 */
export const fixHost = (path?: string, defaultValue = '') => {
  if (!path) {
    return defaultValue
  }

  if (path.startsWith('http')) {
    return path
  }

  return path
}

/*
  智能省略名称
*/
export const splitFileTitle = (title) => {
  if (!title) {
      return ['', '']
  }

  const typeLength = title.split('.').pop().length
  const rightLength = typeLength + 2

  let right = title.slice(-rightLength)

  let tailCnt = rightLength;

  if (/^[a-zA-Z0-9.\-_]+$/.test(right)) {
      tailCnt = rightLength;
  } else {
      tailCnt = 5;
  }


  const left = title.slice(0, - tailCnt);
  right = title.slice(- tailCnt)

  return [left, right];
}
